/** Background tuition calculation polling — keep conservative to reduce API load. */
export const CALCULATION_CYCLE_POLL_INTERVAL_MS = 60_000;

export const CALCULATION_CYCLE_HISTORY_PAGE_SIZE = 10;

export const CALCULATION_CYCLE_OVERLAP_CHECK_PAGE_SIZE = 100;

export const CALCULATION_CYCLE_OVERLAP_CHECK_MAX_PAGES = 5;

/** Hydrated SSR data stays fresh so the client does not refetch on mount. */
export const CALCULATION_CYCLE_STALE_TIME_MS = 30_000;
